import React from 'react'
import { Link } from 'react-router-dom'

import { footerCompany, footerLink2, footerSocial } from '../data/data'
// import { FiSend } from 'react-icons/fi'

import logo from '../assets/images/branding/logo-hap-bco.svg'
import { LuMapPin } from 'react-icons/lu'

export default function Footer() {
    return (
        <>
            <footer className="bg-footer">
                <div className="container">
                    <div className="row">
                        <div className="col-12">
                            <div className="pb-3 mt-5">
                                <div className="row">
                                    <div className="col-lg-4 col-12 mb-0 mb-md-4 pb-0 pb-md-2">
                                        <p className='md:pr-3'>Valoramos cada vida humana confiada a nuestras manos y trabajamos constantemente para cumplir con las expectativas de nuestros pacientes.</p>
                                        <ul className="list-unstyled social-icon foot-social-icon mb-0 mt-4">
                                            {footerSocial.map((item, index) => {
                                                let Icon = item.icon
                                                return (
                                                    <li className="list-inline-item m-x-2" key={index}><Link to={item.link} target="_blank" className="rounded"><Icon className="fea icon-sm align-middle" title={item.title}></Icon></Link></li>
                                                )
                                            })}
                                        </ul>
                                    </div>

                                    <div className="col-lg-4 col-md-8 col-12 mt-4 mt-sm-0 pt-2 pt-sm-0">
                                        <h6 className="footer-head text-uppercase small">Nosotros</h6>
                                        <ul className="list-unstyled footer-list mt-4">
                                            {footerCompany.map((item, index) => {
                                                return (
                                                    <li key={index}><Link to={item.link} className="text-foot"><i className="mdi mdi-chevron-right me-1"></i> {item.title}</Link></li>
                                                )
                                            })}
                                        </ul>
                                    </div>

                                    <div className="col-lg-3 col-md-4 col-12 mt-4 mt-sm-0 pt-2 pt-sm-0">
                                        <h5 className="footer-head text-uppercase small">Sucursales</h5>
                                        <Link className='text-light' to={'https://maps.app.goo.gl/34PzFWjBqtGvspeb6'} target='_blank'>
                                            <h6 className="text-uppercase small mt-2 fw-bold"><LuMapPin /> Centro</h6></Link>
                                        <p className="mt-1">
                                            M. Hidalgo 329, Centro, 37000 León de los Aldama, Gto.
                                        </p>
                                        <Link className='text-light' to={'https://maps.app.goo.gl/hLn59YiQRDeeoiS96'} target='_blank'>
                                            <h6 className="text-uppercase small mt-2 fw-bold"><LuMapPin /> Puerto Interior</h6>
                                        </Link>
                                        <p className="mt-1">
                                            Avenida Mineral del Cata #901, esq Mineral de Rayas, Puerto Interior, 36275 Silao, Gto.
                                        </p>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

                <div className="container">
                    <div className="row">
                        <div className="col-12">
                            <div className="py-3 footer-bar">
                                <div className="container text-center">
                                    <div className="row align-items-center">
                                        <div className="col-sm-6">
                                            <div className="text-sm-start">
                                                <Link to="/" className="logo-footer">
                                                    <img src={logo} alt="" className="img-fluid w-25" />
                                                </Link>
                                            </div>
                                        </div>

                                        <div className="col-sm-6 mt-4 mt-sm-0 pt-2 pt-sm-0">
                                            <ul className="list-unstyled footer-list terms-service text-sm-end mb-0">
                                                {footerLink2.map((item, index) => {
                                                    return (
                                                        <li className="list-inline-item mb-0" key={index}><Link to={item.link} className="text-foot fw-medium me-2" target={item.target}><i className="mdi mdi-circle-small"></i> {item.title}</Link></li>
                                                    )
                                                })}
                                            </ul>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

                <div className="py-4 footer-bar">
                    <div className="container text-center">
                        <div className="row justify-content-center">
                            <div className="col-sm-12">
                                <p className="mb-0">© {new Date().getFullYear()} Hospital Aranda de La Parra.</p>
                            </div>
                        </div>
                    </div>
                </div>
            </footer>
        </>
    )
}
